/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import {
  Button,
  Col,
  DatePicker,
  Empty,
  Form,
  Input,
  notification,
  Pagination,
  Row,
  Select,
  Skeleton,
  Space,
  Table,
  Tabs,
  Tooltip,
  Typography,
  Image,
} from 'antd';
import {
  LikeFilled,
  DislikeFilled,
  ArrowLeftOutlined,
  DownOutlined,
  EyeOutlined,
  MoreOutlined,
  SearchOutlined,
  CloseOutlined,
  FileImageFilled,
  DownloadOutlined,
  FilePdfOutlined,
} from '@ant-design/icons';
import moment from 'moment';
import { connect } from 'react-redux';
// import { getChecksDetails } from '../redux/pihEquipmentDetails/action';
import get from 'lodash/get';
import {
  getEquipChecksHistory,
  getEquipHistoryDetails,
} from '../../redux/admin/checksHistory/action';
import { AWS_IMAGE_URL } from '../../config';
import { Toggle, Button as CrcButton } from '@crc-evans/ui-components';

const { Title, Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

/** Custom dropdown for modern UI – matches heat-profile modal styling (Form.Item compatible: value + onChange) */
const CustomSelect = ({ value, onChange, options = [], placeholder = 'Select', disabled = false, onSelect }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);
  const normalizedOptions = options.map((opt) =>
    typeof opt === 'string' ? { value: opt, label: opt } : { value: opt.value, label: opt.label ?? opt.value }
  );
  const selectedLabel = normalizedOptions.find((o) => o.value === value)?.label ?? value ?? '';

  useEffect(() => {
    if (!open) return;
    const onDocClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  const handleOptionClick = (optValue) => {
    onChange(optValue);
    onSelect && onSelect(optValue);
    setOpen(false);
  };

  return (
    <div
      ref={containerRef}
      className={`heat-profile-custom-select ${open ? 'open' : ''} ${disabled ? 'disabled' : ''}`}
    >
      <div
        className="heat-profile-custom-select-trigger"
        onClick={() => !disabled && setOpen((o) => !o)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') e.preventDefault();
          if (e.key === 'Escape') setOpen(false);
        }}
        role="combobox"
        aria-expanded={open}
        aria-haspopup="listbox"
        tabIndex={disabled ? -1 : 0}
      >
        <span className="heat-profile-custom-select-value">
          {selectedLabel || <span className="placeholder">{placeholder}</span>}
        </span>
        <DownOutlined className="heat-profile-custom-select-arrow" />
      </div>
      {open && (
        <div className="heat-profile-custom-select-dropdown" role="listbox">
          {normalizedOptions.map((opt) => (
            <div
              key={opt.value}
              className={`heat-profile-custom-select-option ${opt.value === value ? 'selected' : ''}`}
              onClick={() => handleOptionClick(opt.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleOptionClick(opt.value)}
              role="option"
              aria-selected={opt.value === value}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const EquipmentHistory = (props) => {
  const {
    dailyActive,
    setDailyActive,
    weeklyActive,
    setWeeklyActive,
    monthlyActive,
    setMonthlyActive,
    selectedProject,
    isChecksLoading,
    checksDetails,
    ongetChecksData,
    equipmentLogs,
    calenderView,
    setCalenderView,

    startDateInput,
    endDateInput,
    selectedDateInput,
    setSelectedDateInput,
    checksPerformed,
  } = props;

  const {
    equipSnoLog,
    setEquipSnoLog,
    equipmentsHistoryLogsForm,
    setAdminMaintenanceType,
    adminMaintenanceType,
    adminIntervalId,
    setAdminIntervalId,
    setAdminMaintenanceId,
    adminMaintenanceId,
    intervalListData,
    setIntervalListData,
    activeKey,
    setActiveKey,
    clickedTableData,
    setClickedTableData,
    configuredMainIntTypes,
    historyData,
    setHistoryData,

    adminMainIntLoading,
    isHistoryDetailsLoading,
    onGetAdminEquipHistoryDetails,
    onGetEquipChecksHistory,
    isChecksHistoryLoading,
    checksHistoryDetails,
    checksReview,
    historyDetailsCount,
    historyCurrentPage,
    setHistoryCurrentPage,
    isModernPage,
    handleCancelHistory,
  } = props;

  const [checksHistoryTable, setChecksHistoryTable] = useState([]);
  const [checksReviewTable, setChecksReviewTable] = useState('');

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const [imageView, setImageView] = useState(false);
  const [imageProperties, setImageProperties] = useState('');
  const [current, setCurrent] = useState(1);
  const [historyPageSize, setHistoryPageSize] = useState(10);
  const [pendingReportDownloadId, setPendingReportDownloadId] = useState(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  /** Enable Search option for table data */
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            // type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            // icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            // type="primary"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          {/* <Button
                type="link"
                size="small"
                onClick={() => {
                  confirm({
                    closeDropdown: false,
                  });
                  setSearchText(selectedKeys[0]);
                  setSearchedColumn(dataIndex);
                }}
              >
                Filter
              </Button> */}
          <Button
            // type="primary"
            size="small"
            icon={<CloseOutlined />}
            onClick={() => {
              confirm({
                closeDropdown: true,
              });
              setCurrent(1);
            }}
          >
            {/* close */}
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex
        ? // <Highlighter
          //   highlightStyle={{
          //     backgroundColor: '#ffc069',
          //     padding: 0,
          //   }}
          //   searchWords={[searchText]}
          //   autoEscape
          //   textToHighlight={text ? text.toString() : ''}
          // />
          text
        : text,
  });

  /** Setting coloumns for project Checks details */
  const historyColoumn = [
    {
      title: 'Project Name',
      dataIndex: 'projectName',
      key: 'projectName',
      align: 'left',
      // width: '60%',
      ellipsis: {
        showTitle: false,
      },
      render: (address) => (
        <Tooltip
          placement="topLeft"
          title={address}
        >
          {address}
        </Tooltip>
      ),
      // ...getColumnSearchProps('projectName'),
    },
    {
      title: 'Scheduled Date',
      dataIndex: 'scheduledDate',
      key: 'scheduledDate',
      align: 'center',
      ellipsis: true,
    },
    {
      title: 'Performed On',
      dataIndex: 'checkPerformedOn',
      key: 'checkPerformedOn',
      align: 'center',
      ellipsis: true,
      render: (text, record) => {
        return <div>{moment(record.checkPerformedOn).format('DD MMM YYYY')}</div>;
      },
      // ...getColumnSearchProps('date'),
    },
    {
      title: 'Performed By',
      dataIndex: 'checkPerformedBy',
      key: 'checkPerformedBy',
      align: 'center',
      ellipsis: {
        showTitle: false,
      },
      render: (address) => (
        <Tooltip
          placement="topLeft"
          title={address}
        >
          {address}
        </Tooltip>
      ),
      // ...getColumnSearchProps('performedBy'),
    },
    {
      title: () => {
        return <MoreOutlined style={{ fontSize: '18px' }} />;
      },
      key: 'action',
      dataIndex: 'action',
      // fixed: 'right',
      width: '120px',
      render: (text, record) => {
        return (
          <Space size={10} className="equipments-history-actions">
            <Tooltip title="View History">
              <span className="icon-18 mr-2 cursor-pointer edit-hover">
                <EyeOutlined
                  className="equipments-history-action-icon"
                  onClick={() => handleViewChecksHistory(record)}
                />
              </span>
            </Tooltip>
            <Tooltip
              title={
                record && record.pihEquipmentCheckDetailId
                  ? 'View / Download Report'
                  : 'Report not available'
              }
            >
              <span
                className="icon-18 mr-2 edit-hover"
                style={{
                  cursor:
                    record && record.pihEquipmentCheckDetailId ? 'pointer' : 'not-allowed',
                  opacity: record && record.pihEquipmentCheckDetailId ? 1 : 0.4,
                }}
                onClick={() => {
                  if (!record || !record.pihEquipmentCheckDetailId) return;
                  handleDownloadReport(record);
                }}
              >
                <FilePdfOutlined className="equipments-history-action-icon" />
              </span>
            </Tooltip>
          </Space>
        );
      },
      align: 'center',
    },
  ];

  /** Setting coloumns for check details */
  const checksColoumn = [
    {
      title: 'Checks',
      dataIndex: 'check',
      key: 'check',
      align: 'left',
      width: '50%',
      ellipsis: {
        showTitle: false,
      },
      render: (address) => (
        <Tooltip
          placement="topLeft"
          title={address}
        >
          {address}
        </Tooltip>
      ),
    },
    {
      title: 'Is Checked',
      dataIndex: 'isChecked',
      key: 'isChecked',
      align: 'center',
      width: '100px',
      ellipsis: true,
      render: (text, record) => {
        return (
          <div>
            <span>
              {record && record.isCheckedField === 1 && (
                <>
                  {record.isChecked === 1 ? (
                    <Tooltip
                      placement="right"
                      title={'Checked'}
                    >
                      <LikeFilled className="icon-24 like" />
                    </Tooltip>
                  ) : record.isChecked === 0 ? (
                    <Tooltip
                      placement="right"
                      title={'Not Checked'}
                    >
                      <DislikeFilled className="icon-24 unlike" />
                    </Tooltip>
                  ) : (
                    record.isChecked === null && (
                      <Tooltip
                        placement="right"
                        title={'Check Not performed'}
                      >
                        <LikeFilled className="icon-24 gradeOut" />
                      </Tooltip>
                    )
                  )}
                </>
              )}
            </span>
          </div>
        );
      },
    },
    {
      title: 'Result',
      dataIndex: 'yesOrNoField',
      key: 'yesOrNoField',
      align: 'center',
      width: '40%',
      ellipsis: true,
      render: (text, record) => {
        return (
          <div>
            {record && record.yesOrNoField !== 1 && record.inputField !== 1 ? (
              <Text>{'-'}</Text>
            ) : (
              <>
                <span>
                  {record && record.yesOrNoField === 1 && (
                    <>
                      {record.yesOrNoFieldValue !== null ? (
                        <Text>{record.yesOrNoFieldValue}</Text>
                      ) : (
                        <Text>{'-'}</Text>
                      )}
                    </>
                  )}
                </span>
                {record && record.inputField === 1 && record.yesOrNoField === 1 && (
                  <span style={{ margin: '0 10px', borderRight: '1px solid gray' }} />
                )}

                {record && record.inputField === 1 && (
                  <span
                    style={{
                      width: '200px',
                      display:
                        record.inputFieldValue !== null &&
                        record.inputFieldValue.toString().length > 15
                          ? 'inline-flex'
                          : 'inline',
                    }}
                  >
                    {record.inputFieldValue !== null ? (
                      <Tooltip
                        title={record.inputFieldValue}
                        style={{
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        <Text
                          style={{
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                          }}
                        >
                          {record.inputFieldValue}
                        </Text>
                      </Tooltip>
                    ) : (
                      <Text>{'-'}</Text>
                    )}
                  </span>
                )}
              </>
            )}
          </div>
        );
      },
    },
    {
      title: () => {
        return <MoreOutlined style={{ fontSize: '18px' }} />;
      },
      key: 'action',
      dataIndex: 'action',
      // fixed: 'right',
      width: '100px',
      render: (text, record) => {
        return (
          <>
            {record && record.checkImageFileKey !== null ? (
              <Tooltip title="View Image">
                <span className="icon-24 mr-2 cursor-pointer edit-hover">
                  <FileImageFilled
                    className="pictureIcon"
                    onClick={() => {
                      handleViewCheckImages(record);
                    }}
                  />
                </span>
              </Tooltip>
            ) : (
              <Tooltip title="No Image Found">
                <span className="icon-24 mr-2 cursor-pointer edit-hover">
                  <FileImageFilled
                    className="gradeOutPictureIcon"
                    style={{ cursor: 'not-allowed' }}
                    // onClick={() => { handleViewCheckImages(record) }}
                  />
                </span>
              </Tooltip>
            )}
          </>
        );
      },
      align: 'center',
    },
  ];

  /** Function to set active tabes and make api call for history Data */
  const handleTabActive = async (event) => {
    // console.log(event);
    setHistoryCurrentPage(1);
    setHistoryPageSize(10);
    setActiveKey(event);
    var obj = {};
    var intervalId = intervalListData.filter((item) => {
      return item.name.toLowerCase() === event;
    });

    setAdminIntervalId(intervalId[0].id);

    obj = {
      equipmentTypeId: equipSnoLog.equipmentTypeId,
      equipmentId: equipSnoLog.id,
      checkIntervalId: intervalId[0].id,
      typeOfMaintenanceId: adminMaintenanceId,
    };

    setHistoryData([]);
    // setInterval(event.toUpperCase());
    // console.log('Selected by Tab List', obj);

    await onGetAdminEquipHistoryDetails(obj);
  };

  /**On select of maintenance type configuring intervals to display */
  const handleMaintenanceChange = async (value) => {
    if (value) {
      setHistoryCurrentPage(1);
      setHistoryPageSize(10);
      setAdminMaintenanceType(value);
      var intervals = configuredMainIntTypes.filter((item) => item.name === value);

      setIntervalListData(intervals[0].check_intervals);
      setAdminIntervalId(intervals[0].check_intervals[0].id);
      setAdminMaintenanceId(intervals[0].id);
      setActiveKey(intervals[0].check_intervals[0].name.toLowerCase());

      var obj = {
        equipmentTypeId: equipSnoLog.equipmentTypeId,
        equipmentId: equipSnoLog.id,
        checkIntervalId: intervals[0].check_intervals[0].id,
        typeOfMaintenanceId: intervals[0].id,
      };
      // console.log('Selected by Maintenance Type', obj);
      await onGetAdminEquipHistoryDetails(obj);
    } else {
      setAdminMaintenanceType('');
      setIntervalListData([]);
      setActiveKey('');
      setCalenderView('day');
      setAdminIntervalId('');
    }
  };

  const handleViewChecksHistory = async (record) => {
    // console.log(record);
    setClickedTableData(true);
    setImageView(false);
    await onGetEquipChecksHistory(record);
  };

  /** Function to Download report (pdf) for specified checks */
  const handleDownloadReport = async (record) => {
    try {
      setPendingReportDownloadId(record.pihEquipmentCheckDetailId);
      await onGetEquipChecksHistory(record);
    } catch (e) {
      setPendingReportDownloadId(null);
      notification.error({
        message: 'Unable to download report.',
      });
    }
  };

  /** Function to view images for specified checks (on click to view) */
  const handleViewCheckImages = async (record) => {
    setImageView(true);
    setImageProperties(record);
  };

  /** Function to Download image */
  const handleDownloadImage = () => {
    let a = document.createElement('a');
    a.href = AWS_IMAGE_URL + '/' + imageProperties.checkImageFileKey;
    a.download = imageProperties.checkImageFileName;
    a.click();
  };

  useEffect(() => {
    if (checksHistoryDetails && checksHistoryDetails.length > 0) {
      setChecksHistoryTable(checksHistoryDetails);
    } else {
      setChecksHistoryTable([]);
    }
  }, [checksHistoryDetails]);

  useEffect(() => {
    if (checksReview) {
      setChecksReviewTable(checksReview);
    } else {
      setChecksReviewTable([]);
    }
  }, [checksReview]);

  useEffect(() => {
    if (!pendingReportDownloadId) return;
    // Use loose numeric comparison — the ID in the record row may be a string while
    // the detail object's `id` field is an integer (or vice-versa).
    if (!checksReview || Number(checksReview.id) !== Number(pendingReportDownloadId)) return;

    const reportFileUrl =
      get(checksReview, 'reportDetails.fileUrl', null) ||
      (get(checksReview, 'reportDetails.key', null)
        ? `${AWS_IMAGE_URL}/${get(checksReview, 'reportDetails.key')}`
        : null);

    if (!reportFileUrl) {
      notification.warning({
        message: 'Report not available for this history item.',
      });
      setPendingReportDownloadId(null);
      return;
    }

    const a = document.createElement('a');
    a.href = reportFileUrl;
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.click();
    setPendingReportDownloadId(null);
  }, [pendingReportDownloadId, checksReview]);

  const historyTableClassName = isModernPage
    ? 'heat-profile-table log-table logDetails_table historyTable equipments-history-table'
    : 'log-table logDetails_table historyTable';

  const handleHistoryPageChange = async (pageNumber, pageSize) => {
    const nextPageSize = pageSize || historyPageSize;
    setHistoryCurrentPage(pageNumber);
    setHistoryPageSize(nextPageSize);
    const obj = {
      equipmentTypeId: equipSnoLog.equipmentTypeId,
      equipmentId: equipSnoLog.id,
      checkIntervalId: adminIntervalId,
      typeOfMaintenanceId: adminMaintenanceId,
      pageSize: nextPageSize,
      pageNumber,
    };
    await onGetAdminEquipHistoryDetails(obj);
  };

  const showHistoryPagination =
    historyDetailsCount > historyPageSize && !(isHistoryDetailsLoading || adminMainIntLoading);

  return (
    <div className={isModernPage ? 'equipments-history-modern' : ''}>
      {!adminMainIntLoading && configuredMainIntTypes.length > 0 ? (
        <div className={`equipment_logs${isModernPage ? ' equipments-history-logs-shell' : ''}`}>
          {!clickedTableData ? (
            <>
              <Form
                form={equipmentsHistoryLogsForm}
                name="basic"
                layout="vertical"
                autoComplete="off"
                getContainer={false}
                className={isModernPage ? 'equipments-history-toolbar' : undefined}
              >
                <Row
                  gutter={24}
                  className=""
                >
                  <Col lg={5}>
                    <Form.Item
                      name="adminMaintenanceType"
                      required
                    >
                      {isModernPage ? (
                        <CustomSelect
                          options={
                            (configuredMainIntTypes || []).map((item) => ({
                              value: item && item.name,
                              label: item && item.name,
                            }))
                          }
                          placeholder={adminMainIntLoading ? 'Loading...' : 'Select Maintenance Type'}
                          disabled={adminMainIntLoading}
                          onSelect={handleMaintenanceChange}
                        />
                      ) : (
                        <Select
                          className="maintenance-select"
                          placeholder={adminMainIntLoading ? 'Loading...' : 'Select Maintenance Type'}
                          showSearch
                          optionFilterProp="children"
                          onChange={handleMaintenanceChange}
                          style={{
                            height: '32px',
                            position: 'relative',
                            top: '7px',
                            width: '100%',
                          }}
                        >
                          {configuredMainIntTypes &&
                            configuredMainIntTypes.map((item, i) => (
                              <Option key={i} value={item && item.name}>
                                {item && item.name}
                              </Option>
                            ))}
                        </Select>
                      )}
                    </Form.Item>
                  </Col>
                  <Col lg={19}>
                    {isModernPage ? (
                      <div className="equipments-history-toggle-wrap">
                        {adminMainIntLoading ? (
                          <span className="equipments-history-toggle-loading">Loading...</span>
                        ) : intervalListData && intervalListData.length > 0 ? (
                          <Toggle
                            options={intervalListData.map((item) => ({
                              id: item.name.toLowerCase(),
                              label: item.name,
                            }))}
                            activeId={activeKey}
                            onToggle={(optionId) => handleTabActive(optionId)}
                            size="medium"
                            className="equipments-history-interval-toggle"
                          />
                        ) : null}
                      </div>
                    ) : (
                      <Tabs
                        className="custom-tab h-100 maintenance_tab"
                        activeKey={activeKey}
                        onTabClick={(key, event) => handleTabActive(key)}
                      >
                        {adminMainIntLoading ? (
                          <TabPane
                            tab={'Loading...'}
                            key={'Loading...'}
                            style={{ position: 'relative' }}
                          />
                        ) : (
                          <>
                            {intervalListData &&
                              intervalListData.map((item, i) => (
                                <TabPane
                                  tab={item.name}
                                  key={item.name.toLowerCase()}
                                  style={{ position: 'relative' }}
                                />
                              ))}
                          </>
                        )}
                      </Tabs>
                    )}
                  </Col>
                </Row>
              </Form>
              <div>
                {/* {calenderView !== 'day' &&
                        <>
                            {checksPerformed && checksPerformed.updatedAt !== null && <Text className='performedDate'>{'Performed On: ' + moment(checksPerformed.updatedAt).format('DD MMM YYYY')}</Text>
                            }
                        </>} */}
              </div>
              {!isModernPage && <div className="custom-line" />}
              <div
                className={isModernPage ? 'equipments-history-table-section equipments-history-list-layout' : ''}
                style={isModernPage ? undefined : { height: 'calc(100vh - 360px)' }}
              >
                {isModernPage ? (
                  <>
                    <div className="equipments-history-table-panel">
                      <div className="equipments-history-table-scroll">
                        <div className="equipments-history-custom-table-container">
                          {(isHistoryDetailsLoading || adminMainIntLoading) ? (
                          <Skeleton active paragraph={{ rows: 8 }} />
                        ) : (
                          <table className="equipments-history-custom-table heat-profile-table">
                            <thead>
                              <tr>
                                <th className="equipments-history-th-left">Project Name</th>
                                <th className="equipments-history-th-center">Scheduled Date</th>
                                <th className="equipments-history-th-center">Performed On</th>
                                <th className="equipments-history-th-left">Performed By</th>
                                <th className="equipments-history-custom-table-actions">
                                  <MoreOutlined style={{ fontSize: '18px' }} />
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {(!historyData || historyData.length === 0) ? (
                                <tr>
                                  <td colSpan={5}>
                                    <Empty description="No data" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                                  </td>
                                </tr>
                              ) : (
                                historyData.map((record, index) => (
                                  <tr key={record.id != null ? record.id : index}>
                                    <td className="equipments-history-cell-left">
                                      <Tooltip placement="topLeft" title={record.projectName}>
                                        <span className="equipments-history-cell-text">{record.projectName}</span>
                                      </Tooltip>
                                    </td>
                                    <td className="equipments-history-cell-center">{record.scheduledDate}</td>
                                    <td className="equipments-history-cell-center">
                                      {record.checkPerformedOn
                                        ? moment(record.checkPerformedOn).format('DD MMM YYYY')
                                        : '-'}
                                    </td>
                                    <td className="equipments-history-cell-left">
                                      <Tooltip placement="topLeft" title={record.checkPerformedBy}>
                                        <span className="equipments-history-cell-text">{record.checkPerformedBy}</span>
                                      </Tooltip>
                                    </td>
                                    <td className="equipments-history-custom-table-actions">
                                      <Space size={10} className="equipments-history-actions">
                                        <Tooltip title="View History">
                                          <span
                                            className="icon-18 mr-2 cursor-pointer edit-hover"
                                            onClick={() => handleViewChecksHistory(record)}
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={(e) => e.key === 'Enter' && handleViewChecksHistory(record)}
                                          >
                                            <EyeOutlined className="equipments-history-action-icon" />
                                          </span>
                                        </Tooltip>
                                        <Tooltip
                                          title={
                                            record && record.pihEquipmentCheckDetailId
                                              ? 'View / Download Report'
                                              : 'Report not available'
                                          }
                                        >
                                          <span
                                            className="icon-18 mr-2 edit-hover"
                                            style={{
                                              cursor:
                                                record && record.pihEquipmentCheckDetailId ? 'pointer' : 'not-allowed',
                                              opacity: record && record.pihEquipmentCheckDetailId ? 1 : 0.4,
                                            }}
                                            onClick={() => {
                                              if (!record || !record.pihEquipmentCheckDetailId) return;
                                              handleDownloadReport(record);
                                            }}
                                            role="button"
                                            tabIndex={0}
                                            onKeyDown={(e) => {
                                              if (e.key === 'Enter' && record?.pihEquipmentCheckDetailId) {
                                                handleDownloadReport(record);
                                              }
                                            }}
                                          >
                                            <FilePdfOutlined className="equipments-history-action-icon" />
                                          </span>
                                        </Tooltip>
                                      </Space>
                                    </td>
                                  </tr>
                                ))
                              )}
                            </tbody>
                          </table>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <Table
                    className={historyTableClassName}
                    columns={historyColoumn}
                    dataSource={[...historyData]}
                    scroll={{ x: '100%', y: '100%' }}
                    pagination={
                      historyDetailsCount > 10
                        ? {
                            position: ['bottomLeft'],
                            showSizeChanger: true,
                            total: historyDetailsCount,
                            defaultPageSize: 10,
                            defaultCurrent: 1,
                            current: historyCurrentPage,
                            onChange: async (pageNumber, pageSize) => {
                              setHistoryCurrentPage(pageNumber);
                              var obj = {
                                equipmentTypeId: equipSnoLog.equipmentTypeId,
                                equipmentId: equipSnoLog.id,
                                checkIntervalId: adminIntervalId,
                                typeOfMaintenanceId: adminMaintenanceId,
                                pageSize: pageSize,
                                pageNumber: pageNumber,
                              };
                              await onGetAdminEquipHistoryDetails(obj);
                            },
                          }
                        : false
                    }
                    loading={isHistoryDetailsLoading || adminMainIntLoading}
                  />
                )}
              </div>
              
              {isModernPage && (
                <div 
                  className="equipments-history-modal-footer" 
                  style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    padding: '16px 24px 20px', 
                    background: '#f9fafb', 
                    borderTop: '1px solid #e5e7eb', 
                    margin: '0 -24px 0', 
                    flexShrink: 0 
                  }}
                >
                  <div className="equipments-history-pagination-wrap" style={{ display: 'flex', alignItems: 'center' }}>
                    {showHistoryPagination && (
                      <Pagination
                        current={historyCurrentPage}
                        total={historyDetailsCount}
                        pageSize={historyPageSize}
                        showSizeChanger
                        pageSizeOptions={['10', '20', '50']}
                        onChange={handleHistoryPageChange}
                        className="heat-profile-pagination equipments-history-pagination"
                      />
                    )}
                  </div>
                  <CrcButton
                    key="close"
                    label="Close"
                    variant="secondary"
                    onClick={handleCancelHistory}
                    size="medium"
                    className="equipments-history-close-btn"
                  />
                </div>
              )}
            </>
          ) : (
            <>
              {!imageView ? (
                <>
                  {/* ── Back button ── */}
                  {isModernPage ? (
                    <button
                      className="equip-history-detail-back-btn"
                      onClick={() => {
                        setClickedTableData(false);
                        setChecksHistoryTable([]);
                        setChecksReviewTable('');
                      }}
                    >
                      <ArrowLeftOutlined style={{ marginRight: 6, fontSize: 13 }} />
                      Back to History
                    </button>
                  ) : (
                    <div className="back_equip_modal">
                      <Tooltip title={' Back'}>
                        <ArrowLeftOutlined
                          onClick={() => {
                            setClickedTableData(false);
                            setChecksHistoryTable([]);
                            setChecksReviewTable('');
                          }}
                        />
                      </Tooltip>
                    </div>
                  )}

                  <Skeleton
                    loading={isChecksHistoryLoading}
                    active
                    style={{ margin: '20px 0' }}
                  >
                    {checksReviewTable && checksReviewTable.isMaintenanceSkipped !== 1 ? (
                      <div style={{ height: 'calc(100vh - 260px)' }}>
                        <Table
                          className={historyTableClassName}
                          columns={checksColoumn}
                          dataSource={[...checksHistoryTable]}
                          pagination={false}
                          scroll={{ x: '100%', y: '100%' }}
                          loading={isChecksHistoryLoading}
                          style={{
                            height: isChecksHistoryLoading
                              ? '60%'
                              : checksReviewTable &&
                                (checksReviewTable.fixes !== (null || '') ||
                                  checksReviewTable.issues !== (null || '') ||
                                  (checksReviewTable.signatureS3Object &&
                                    checksReviewTable.signatureS3Object.objectUrl))
                              ? '60%'
                              : '100%',
                          }}
                        />
                        <Skeleton loading={isChecksHistoryLoading} active>
                          {checksReviewTable &&
                            (checksReviewTable.fixes !== (null || '') ||
                              checksReviewTable.issues !== (null || '') ||
                              (checksReviewTable.signatureS3Object &&
                                checksReviewTable.signatureS3Object.objectUrl)) && (
                              isModernPage ? (
                                /* ── Modern fixes / issues / signature panel ── */
                                <div className="equip-history-review-panel">
                                  {checksReviewTable.fixes !== (null || '') && (
                                    <div className="equip-history-review-card">
                                      <p className="equip-history-review-label">Fixes</p>
                                      <p className="equip-history-review-text">
                                        {isChecksHistoryLoading ? '' : (checksReviewTable.fixes || '—')}
                                      </p>
                                    </div>
                                  )}
                                  {checksReviewTable.issues !== (null || '') && (
                                    <div className="equip-history-review-card">
                                      <p className="equip-history-review-label">Issues</p>
                                      <p className="equip-history-review-text">
                                        {isChecksHistoryLoading ? '' : (checksReviewTable.issues || '—')}
                                      </p>
                                    </div>
                                  )}
                                  {checksReview && checksReview.checkDetailImages && (
                                    <div className="equip-history-review-card equip-history-review-card--full">
                                      <p className="equip-history-review-label">Images</p>
                                      <div className="equip-history-images-wrap">
                                        <Image.PreviewGroup>
                                          {checksReview.checkDetailImages.map((data) =>
                                            data.fileKey && (
                                              <div key={data.fileKey} className="equip-history-image-item">
                                                <Image
                                                  width={150}
                                                  height={150}
                                                  src={AWS_IMAGE_URL + '/' + data.fileKey}
                                                />
                                                <span className="equip-history-image-name">{data.fileName}</span>
                                              </div>
                                            )
                                          )}
                                        </Image.PreviewGroup>
                                      </div>
                                    </div>
                                  )}
                                  {checksReviewTable.signatureS3Object &&
                                    checksReviewTable.signatureS3Object.objectUrl && (
                                      <div className="equip-history-review-card">
                                        <p className="equip-history-review-label">Signature</p>
                                        <div className="equip-history-signature-box">
                                          <img
                                            src={checksReviewTable.signatureS3Object.objectUrl}
                                            alt="signature"
                                            className="equip-history-signature-img"
                                          />
                                        </div>
                                      </div>
                                    )}
                                </div>
                              ) : (
                                /* ── Legacy fixes / issues / signature panel ── */
                                <Row
                                  gutter={24}
                                  style={{
                                    height: '36%',
                                    overflow: 'auto',
                                    marginRight: 0,
                                    zIndex: 1,
                                    position: 'relative',
                                  }}
                                >
                                  {checksReviewTable.fixes !== (null || '') && (
                                    <Col span={12} className="issues_comments">
                                      <Text>Fixesss:</Text>
                                      <Input.TextArea
                                        rows={2}
                                        value={isChecksHistoryLoading ? '' : checksReviewTable.fixes}
                                      />
                                    </Col>
                                  )}
                                  {checksReviewTable.issues !== (null || '') && (
                                    <Col span={12} className="issues_comments">
                                      <Text>Issues:</Text>
                                      <Input.TextArea
                                        rows={2}
                                        value={isChecksHistoryLoading ? '' : checksReviewTable.issues}
                                      />
                                    </Col>
                                  )}
                                  {checksReview && checksReview.checkDetailImages && (
                                    <Col span={24} className="issues_comments">
                                      <Text>Images:</Text>
                                      <div style={{ height: '250px', overflow: 'auto', marginTop: '12px' }}>
                                        <Image.PreviewGroup>
                                          <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '16px' }}>
                                            {checksReview.checkDetailImages.map((data) =>
                                              data.fileKey && (
                                                <div
                                                  key={data.fileKey}
                                                  style={{ height: '210px', width: '150px', overflow: 'none', display: 'flex', flexDirection: 'column', marginBottom: '8px', marginRight: '8px' }}
                                                >
                                                  <Image width={150} height={150} src={AWS_IMAGE_URL + '/' + data.fileKey} />
                                                  <Text>{data.fileName}</Text>
                                                </div>
                                              )
                                            )}
                                          </div>
                                        </Image.PreviewGroup>
                                      </div>
                                    </Col>
                                  )}
                                  {checksReviewTable.signatureS3Object &&
                                    checksReviewTable.signatureS3Object.objectUrl && (
                                      <Col span={12} className="issues_comments" style={{ display: 'grid' }}>
                                        <Text>Signature:</Text>
                                        <img src={checksReviewTable.signatureS3Object.objectUrl} alt="signature" />
                                      </Col>
                                    )}
                                </Row>
                              )
                            )}
                        </Skeleton>
                      </div>
                    ) : (
                      /* ── Maintenance Skipped view ── */
                      isModernPage ? (
                        <div className="equip-history-skipped-card">
                          <div className="equip-history-skipped-header">
                            <span className="equip-history-skipped-badge">
                              Maintenance Skipped
                            </span>
                            {checksReviewTable.updatedAt !== null && (
                              <span className="equip-history-performed-badge">
                                Performed On: {moment(checksReviewTable.updatedAt).format('DD MMM YYYY')}
                              </span>
                            )}
                          </div>
                          <div className="equip-history-skipped-reason">
                            <p className="equip-history-skipped-reason-label">Reason</p>
                            <p className="equip-history-skipped-reason-text">
                              {checksReviewTable.maintenanceSkippedReason !== null
                                ? checksReviewTable.maintenanceSkippedReason
                                : 'No reason mentioned'}
                            </p>
                          </div>
                          {checksReviewTable.signatureS3Object &&
                            checksReviewTable.signatureS3Object.objectUrl && (
                              <div className="equip-history-skipped-signature">
                                <p className="equip-history-skipped-reason-label">Signature</p>
                                <div className="equip-history-signature-box">
                                  <img
                                    src={checksReviewTable.signatureS3Object.objectUrl}
                                    alt="signature"
                                    className="equip-history-signature-img"
                                  />
                                </div>
                              </div>
                            )}
                        </div>
                      ) : (
                        <div style={{ margin: '20px 0', display: 'grid' }}>
                          <p style={{ display: 'inline-flex' }}>
                            <Text style={{ color: '#EF314C', fontSize: 16, fontWeight: '600' }}>
                              Maintenance Skipped
                            </Text>
                            {checksReviewTable.updatedAt !== null && (
                              <Text
                                className="performedDate"
                                style={{ top: 0, left: '20px', padding: '1px 12px ' }}
                              >
                                {'Performed On: ' +
                                  moment(checksReviewTable.updatedAt).format('DD MMM YYYY')}
                              </Text>
                            )}
                          </p>
                          <Text>
                            <b>Reason:</b>{' '}
                            {checksReviewTable.maintenanceSkippedReason !== null
                              ? checksReviewTable.maintenanceSkippedReason
                              : 'No reason mentioned'}
                          </Text>
                          {checksReviewTable.signatureS3Object &&
                            checksReviewTable.signatureS3Object.objectUrl && (
                              <div>
                                <Text>Signature:</Text>
                                <img
                                  src={checksReviewTable.signatureS3Object.objectUrl}
                                  alt="signature"
                                  style={{ width: '30%', padding: '20px 0' }}
                                />
                              </div>
                            )}
                        </div>
                      )
                    )}
                  </Skeleton>
                </>
              ) : (
                /* ── Image preview view ── */
                <>
                  {isModernPage ? (
                    <button
                      className="equip-history-detail-back-btn"
                      onClick={() => { setImageView(false); setImageProperties(''); }}
                    >
                      <ArrowLeftOutlined style={{ marginRight: 6, fontSize: 13 }} />
                      Back to Checks
                    </button>
                  ) : (
                    <div className="back_equip_modal">
                      <Tooltip title={' Back'}>
                        <ArrowLeftOutlined onClick={() => { setImageView(false); setImageProperties(''); }} />
                      </Tooltip>
                    </div>
                  )}
                  <Row className="imagePreview">
                    <Col span={6}>
                      <Image
                        width={200}
                        src={AWS_IMAGE_URL + '/' + imageProperties.checkImageFileKey}
                      />
                      <a onClick={handleDownloadImage}>
                        <Text>
                          <Tooltip title={imageProperties.checkImageFileName}>
                            {imageProperties.checkImageFileName}{' '}
                          </Tooltip>
                        </Text>
                        <DownloadOutlined />
                      </a>
                    </Col>
                  </Row>
                </>
              )}
            </>
          )}
        </div>
      ) : (
        <div>{adminMainIntLoading ? <Table loading={adminMainIntLoading} /> : <Empty />}</div>
      )}
    </div>
  );
};

const mapStateToProps = ({ historyReducer }) => {
  const isChecksHistoryLoading = get(historyReducer, 'isChecksHistoryLoading', false);
  const checksHistoryDetails = get(historyReducer, 'equipMainChecksHistory', []);
  const historyDetailsCount = get(historyReducer, 'historyCount', null);
  const checksReview = get(historyReducer, 'pihEquipmentCheckDetail', {});
  return {
    isChecksHistoryLoading,
    checksHistoryDetails,
    checksReview,
    historyDetailsCount,
  };
};

const mapDispatchToProps = {
  onGetAdminEquipHistoryDetails: getEquipHistoryDetails,
  onGetEquipChecksHistory: getEquipChecksHistory,
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipmentHistory);
